export const CampaignsPaths = {
    grid: "/",
    editDashboard: ":campaignId/dashboard",
    edit: ":campaignId",
} as const;
